const VuexComputed = {
  install (Vue) {
    /**
     * computed property factory
     * @param  {String} statePropName           state property name in Vuex store
     * @param  {String} [mutationType = false]  name of mutation updating state property
     * @param  {Number} [debounce = false]      wait time argument passed to lodash debounce function
     * @return {Object}                         the new computed property to inject
     */
    const createComputed = ({statePropName, mutationType = false, debounce = false}) => {
      const comp = {
        get () {
          return this.$store.state[statePropName]
        }
      },
      fn = function(newValue) {
        this.$store.commit(mutationType, newValue)
      }

      if (mutationType)
        comp.set = (Number.isInteger(debounce))?
          _.debounce(fn, debounce) : fn
      return comp
    }

    Vue.mixin({
      beforeCreate () {
        this.$options.computed = this.$options.computed || {}
        Object.keys(this.$options.vuexComputed || {}).forEach(key => {
          const options = this.$options.vuexComputed[key]
          this.$options.computed[key] = createComputed(options)
        })
      }
    })
  }
}

export default VuexComputed



// WEBPACK FOOTER //
// ./client/utils/VuexComputed.js